/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { InfinitySpin } from "react-loader-spinner";
import { Button, Card, TextField } from "@mui/material";
class DigitalMenuLeads extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
      start_date: "",
      end_date: "",
      type: "",
      currentPage: 1,
      page:1,
      totalPages: 1,
      total: 0,
      guestleadstotal: 0,
      restro_id:"",
      per_page: 10,
      rest: "",
      restaurent:[]
    };
  }

  componentDidMount() {
    this.fetchData(this.state.page, this.state.per_page);
    this.fetchRestData()
  }

  fetchData(page, per_page,start_date,end_date,rest) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    if(rest){
      restro_id = rest;
    }

    var type = "1";

  
    axios
      .post(endpoints.getRegistrationData, {
        page,
        per_page,
        user_id,
        restro_id,
        type,
        start_date,
        end_date
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          guestleadstotal: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        //console.log(response.data);
      });
  }


  guestFilter= () =>{
    if(!this.start_date && !this.end_date && !this.rest){
alert("Please Select Any Filter")
return;
    }
    this.setState({ page:1, per_page: 10 }, () => {
      this.fetchData(this.state.page,this.state.per_page,this.start_date,this.end_date,this.rest);
    });
    
  }

  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      // window.location.reload(true);
      //console.log("response", response);
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  handlePageChange = (page) => {
    this.fetchData(page, this.state.per_page,this.start_date,this.end_date,this.rest);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ per_page: newPerPage }, () => {
      this.fetchData(page, newPerPage,this.start_date,this.end_date,this.rest);
    });
  };

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;
    const links = this.state.restaurent;
    const b = this.state.total;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    // const b = JSON.stringify(a)
    const dates = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[dates.getMonth()];
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        name: "Name",
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        name: "Mobile Number",
        selector: (row) => row.mobilenumber,
        cellExport: (row) => row.mobilenumber,
        sortable: true,
      },
      {
        name: "Birthday Date",
        selector: (row) => row.birthday,
        cellExport: (row) => row.birthday,
        sortable: true,
      },
      // {
      //   name: "Start Date",
      //   selector: (row) => row.start_date,
      //   cellExport: (row) => row.start_date,
      //   sortable: true,
      // },
      // {
      //   name: "Birthday Month",
      //   selector: (row) => row.birthmonth,
      //   cellExport: (row) => row.birthmonth,
      //   sortable: true,
      // },
      {
        name: "Restaurant",
        selector: (row) => row.rest_name,
        cellExport: (row) => row.rest_name,
        sortable: true,
      },
    ];

    const data = a;
    const tableData = {
      columns,
      data,
    };

    const onStartChange = (e) => {
      this.start_date = e.target.value;
    };
    const onEndChange = (e) => {
      this.end_date = e.target.value;
    };
   
    const onRestChange = (e) => {
      this.rest = e.target.value;
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Guest Leads</h2>

        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="col-md-3">
          
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                 
                />
              </div>


              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
               ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={this.guestFilter}
                    variant="contained"
                    style={{ color: "white" }}
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>

        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
          <DataTable
                defaultSortField="id"
                pagination
                paginationServer
                paginationTotalRows={this.state.guestleadstotal}
                onChangePage={this.handlePageChange}
                onChangeRowsPerPage={this.handlePerRowsChange}
                progressPending={!this.state.DataisLoaded}
              />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default DigitalMenuLeads;
